/**
 * Root layout wrapper that provides CommandPalette functionality
 * inside the Router context
 */
import React from 'react';
import { Outlet } from 'react-router';
import { CommandPaletteProvider } from '../primitives/CommandPalette';
import { logWithTimestamp } from '../../utils/dateHelpers';
import { useDarkMode } from '../../hooks/useDarkMode';

export const RootLayout = () => {
  const { toggleDarkMode } = useDarkMode();

  return (
    <CommandPaletteProvider
      onToggleDarkMode={toggleDarkMode}
      onSidebarToggle={() => {
        logWithTimestamp('Sidebar toggle requested');
      }}
      onNewTab={() => {
        logWithTimestamp('New tab requested');
      }}
      onShowHelp={() => {
        logWithTimestamp('Help requested');
      }}
    >
      <Outlet />
    </CommandPaletteProvider>
  );
};

export default RootLayout;